module.exports = __webpack_public_path__ + "img/name-decoration.27ec780e.png";